import React from 'react';

const PageHeader = ({ title }) => {
  return (
    <section className="relative py-24 px-6 flex items-center justify-center overflow-hidden border-b border-white/5">
      {/* Background Glow Effects */}
      <div className="absolute top-0 left-1/4 w-64 h-64 bg-electric-green/10 rounded-full blur-[100px] pointer-events-none"></div>
      <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-blue-500/10 rounded-full blur-[100px] pointer-events-none"></div>

      <div className="relative z-10 text-center">
        <h1 className="text-5xl md:text-7xl font-extrabold text-white tracking-tight drop-shadow-[0_0_15px_rgba(255,255,255,0.1)]">
          {title}
        </h1>
      </div>
    </section>
  );
};

export default PageHeader;